export const TXN_TYPE = {
  rewards: 'Campaign Rewards',
  withdraw: 'Withdraw',
};
